/**
 * Mechanic Dashboard — Redirects to the DoorDash-style Provider Dashboard
 * Both mechanic and roadside_tech roles use the same unified provider experience
 */
import React from 'react';
import ProviderDashboard from '../provider/ProviderDashboard';

export default function MechanicDashboard() {
  return <ProviderDashboard />;
}
